"use client";
import BrandsSwiper from "@/app/components/elements/swipers/BrandsSwiper";
import { StoreBrand } from "@/app/lib/features/store/store.types";
import { SectionItem } from "@/app/lib/features/home/home.types";

interface StoreBrandsSectionProps {
  brands: StoreBrand[];
}

const StoreBrandsSection = ({ brands }: StoreBrandsSectionProps) => {
  if (!brands.length) return null;

  const sectionItems: SectionItem[] = brands.map((brand) => ({
    id: brand.id,
    title: brand.name,
    name: brand.name,
    slug: brand.slug,
    image: brand.image_url,
  }));

  return (
    <section>
      <BrandsSwiper brands={sectionItems} />
    </section>
  );
};

export default StoreBrandsSection;
